// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__b6GXF","row":"styles_row__2O4EN"};